import { render, staticRenderFns } from "./ClientRegisterPage.vue?vue&type=template&id=22a3f6a4&scoped=true"
import script from "./ClientRegisterPage.vue?vue&type=script&lang=js"
export * from "./ClientRegisterPage.vue?vue&type=script&lang=js"
import style0 from "./ClientRegisterPage.vue?vue&type=style&index=0&id=22a3f6a4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a3f6a4",
  null
  
)

export default component.exports